import { SxProps, Theme } from "@mui/material";

import APToggleButton from "./APToggleButton";

const VisibilityButton = ({
  isVisible,
  onToggle,
  sx,
}: {
  isVisible: boolean;
  onToggle: (newVisibility: boolean) => void;
  sx?: SxProps<Theme>;
}) => {
  return (
    <APToggleButton
      aria-label="quote-visibility"
      isToggled={isVisible}
      onToggle={onToggle}
      toggledOnIcon="visibility"
      toggledOffIcon="visibility-off"
      sx={sx}
    />
  );
};

export default VisibilityButton;
